import { ThunkHelper } from 'invision-core';
import { values } from 'ramda';
export var GIFT_CARD_RESULT = {
  BEGIN: 'GIFT_CARD_RESULT_BEGIN',
  SUCCESS: 'GIFT_CARD_RESULT_SUCCESS',
  FAILURE: 'GIFT_CARD_RESULT_FAILURE'
};
var GIFT_CARD_RESULT_EVENTS = [GIFT_CARD_RESULT.BEGIN, GIFT_CARD_RESULT.SUCCESS, GIFT_CARD_RESULT.FAILURE];
var giftCardResultPromise = function giftCardResultPromise(dispatch, giftCardId, pageNumber, pageSize) {
  var events = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : GIFT_CARD_RESULT_EVENTS;
  return ThunkHelper(dispatch, events, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveGiftCardRedemption',
    data: {
      Id: giftCardId
    }
  });
};
export var getGiftCardResult = function getGiftCardResult(giftCardId) {
  return function (dispatch) {
    return giftCardResultPromise(dispatch, giftCardId);
  };
};
export var RESEND_GIFT_CARD_NOTIFICATION = {
  BEGIN: 'RESEND_GIFT_CARD_NOTIFICATION_BEGIN',
  SUCCESS: 'RESEND_GIFT_CARD_NOTIFICATION_SUCCESS',
  FAILURE: 'RESEND_GIFT_CARD_NOTIFICATION_FAILURE'
};
export var RESEND_GIFT_CARD_NOTIFICATION_TYPES = values(RESEND_GIFT_CARD_NOTIFICATION);
var resendGiftCardNotificationPromise = function resendGiftCardNotificationPromise(dispatch, notificationInfo) {
  return ThunkHelper(dispatch, RESEND_GIFT_CARD_NOTIFICATION_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/ResendGiftCardNotification',
    data: {
      NotifySender: notificationInfo.notifySender,
      RedemptionId: notificationInfo.Id,
      RecipientEmail: notificationInfo.RecipientEmail,
      RecipientName: notificationInfo.RecipientName,
      SenderName: notificationInfo.SenderName,
      SenderMessage: notificationInfo.message
    }
  });
};
export var submitResendGiftCardNotification = function submitResendGiftCardNotification(notificationInfo) {
  return function (dispatch) {
    return resendGiftCardNotificationPromise(dispatch, notificationInfo);
  };
};